import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  CountryLanguages,
  FlyoutLangSelectConfirmation
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { FlyoutLangSelector } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { MessageBanner } from '@com-delta-omnichannel/mach-core-js';
import { ContentAlertAdvisory } from './models/alert-advisories.interfaces';

@Component({
  selector: 'idp-alert-advisories',
  standalone: true,
  templateUrl: './alert-advisories.component.html',
  styleUrls: ['./alert-advisories.component.scss'],
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None
})
export class AlertAdvisoriesUiComponent implements AfterViewInit, OnDestroy {
  ngOnDestroy(): void {
    this.messageBanner?.destroy();
  }

  @Input() content: ContentAlertAdvisory = {} as ContentAlertAdvisory;
  @Input() flyOutConfirmationContent!: FlyoutLangSelectConfirmation | null;
  @Input() flyoutLangSelectorContent!: FlyoutLangSelector | null;
  @Input() showConfirmationModal!: boolean | null;
  @Input() searchList!: CountryLanguages[] | null;
  @Input() showSelectorModal!: boolean | null;
  @Output() alertAdvisoryClosed = new EventEmitter<string>();
  @Output() analyticsEvent = new EventEmitter<HTMLElement>();
  @ViewChild('advisoryContent') advisoryContent!: ElementRef;
  findAlertAdvisories!: ElementRef;

  messageBanner!: MessageBanner;

  ngAfterViewInit() {
    this.messageBanner = new MessageBanner(this.content.messageBanner);

    this.messageBanner.onClose(() => {
      this.alertAdvisoryClosed.emit('advisory');
    });

    const anchor = this.advisoryContent?.nativeElement.querySelector('a');
    if (anchor) {
      anchor.classList.add('link');
      anchor.setAttribute('data-acdl-name', anchor.textContent?.trim() || '');
      anchor.setAttribute('data-acdl-action', 'header:alert and advisories:');
      this.findAlertAdvisories = new ElementRef(anchor);
      anchor.addEventListener('click', () => {
        this.analyticsEvent.emit(this.findAlertAdvisories.nativeElement);
      });
    }
  }

  close(screenName: string) {
    this.alertAdvisoryClosed.emit(screenName);
  }
}
